import { Router } from '@angular/router';
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { Customer } from '@app/shared';

@Component({
  selector: 'app-report-picking',
  templateUrl: './report-picking.component.html',
  styleUrls: ['./report-picking.component.scss']
})
export class ReportPickingComponent implements OnInit {
  @Output() exportExcel = new EventEmitter<any>();

  @Input() customers: Customer;
  data: any = {};
  displayMonths = 1;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  backRouter() {
    this.router.navigate(['/reports/overview']);
  }

  downloadXlsx() {
    const params = {
      customerCode: this.data.customer,
      startDate: this.toFormatDate(this.data.dateFrom),
      endDate: this.toFormatDate(this.data.dateTo)
    };
    this.exportExcel.emit(params);
  }

  toFormatDate(date): string {
    if (!date) {
      return '';
    }

    if (date.year && date.month && date.day) {
      return this.formatDateParts(date.day, date.month, date.year);
    }

    if (date instanceof Date) {
      return this.formatDateParts(
        date.getDate(),
        date.getMonth() + 1,
        date.getFullYear()
      );
    }

    const stringDate = String(date);
    if (stringDate.includes('/')) {
      return stringDate;
    }

    const [year, month, day] = stringDate.split('-');
    return this.formatDateParts(day, month, year);
  }

  private formatDateParts(day: any, month: any, year: any): string {
    return `${this.padDatePart(day)}/${this.padDatePart(month)}/${year}`;
  }

  private padDatePart(value: any): string {
    return String(value).padStart(2, '0');
  }

}
